import React, {useState, useEffect} from 'react';
import {TAGS} from "../core/constants";


/**
 * MultiSelect
 * Created on 1/15/24
 */
const MultiSelect = ({preselectedTags, onTagSelected}) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState([]);

    const selectTag = (tag) => {
        const found = selected.find(t => t.id === tag.id);
        const next = found ? selected.filter(t => t.id !== tag.id) : [...selected, tag];

        setSelected(next);
        onTagSelected(next);
    }

    useEffect(() => {
        if (preselectedTags) {
            setSelected(preselectedTags)
        }
    }, [preselectedTags]);

    return (
        <div className="relative">
            <div className="flex flex-wrap items-center gap-1 border border-base-300 rounded-md bg-base-100 p-1.5 min-h-[2.25rem]">
                {selected?.map(tag => (
                    <span key={tag.id} className="badge badge-sm badge-accent gap-1">
                        {tag.label}
                        <button type="button" className="font-bold leading-none" onClick={() => selectTag(tag)}>
                            &times;
                        </button>
                    </span>
                ))}
                <button
                    type="button"
                    onClick={() => setOpen(curr => !curr)}
                    className="ml-auto btn btn-ghost btn-xs"
                >
                    {open ? '▲' : '▼'}
                </button>
            </div>

            {open && (
                <div className="absolute z-40 w-full mt-1 bg-base-100 border border-base-300 rounded-md shadow-lg max-h-[220px] overflow-y-auto">
                    {TAGS.map(tag => (
                        <button
                            key={tag.id}
                            type="button"
                            onClick={() => selectTag(tag)}
                            className="w-full text-left px-2.5 py-1.5 text-sm hover:bg-base-200"
                        >
                            {tag.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}

export default MultiSelect;
